{
  "id": "campaign-108",
  "name": "Stately Lawns",
  "seed": "campaign:108",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....CCCCCCCC....",
    "....UCCCCCCU....",
    ".......CC.......",
    "......tCCt...x..",
    ".***t..CC.,t***.",
    ".***..CCCC,,***.",
    "..T..TCwwCT..T..",
    "......CwwC......",
    "....t.CwwC.t....",
    "......CCCC......",
    "..Y...hCCh...Y..",
    ".......CC.......",
    ".......CC.......",
    "......tCCt......",
    "..x....x..x.....",
    "S..............."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 12,
      "y": 11
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 15
    },
    {
      "kind": "squirrel",
      "x": 14,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 15,
      "y": 1
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 2
    },
    {
      "kind": "rare",
      "x": 10,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 108,
  "biome": "estate",
  "par": {
    "reel": 6744,
    "push": 6105,
    "selfPropelled": 5490,
    "tractor": 4515,
    "zeroTurn": 3772,
    "fairway": 2476
  },
  "goldTime": {
    "reel": 6504,
    "push": 5923,
    "selfPropelled": 5346,
    "tractor": 4475,
    "zeroTurn": 3670,
    "fairway": 2314
  },
  "routeTries": {
    "par": {
      "reel": 4,
      "push": 0,
      "selfPropelled": 14,
      "tractor": 14,
      "zeroTurn": 21,
      "fairway": 21
    },
    "gold": {
      "reel": 32,
      "push": 39,
      "selfPropelled": 46,
      "tractor": 31,
      "zeroTurn": 36,
      "fairway": 38
    }
  }
}
